import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ChangePasswordDialogComponent } from './change-password-dialog.component';
import { GoMaterialModule } from '@go-modules/go-material.module';
import { PasswordVisibilityToggleModule } from '@go-modules/directives/password-visibility-toggle/password-visibility-toggle.module';
import { MatTooltipModule } from '@angular/material/tooltip';

@NgModule({
	imports: [
		CommonModule,
		MatTooltipModule,
		FormsModule,
		ReactiveFormsModule,
		TranslateModule,
		GoMaterialModule,
		PasswordVisibilityToggleModule
	],
	declarations: [
		ChangePasswordDialogComponent
	],
	exports: [
		ChangePasswordDialogComponent
	]
})
export class ChangePasswordDialogModule {}
